import React, { useState } from "react"
import Title from "./Title"
import { FaRegCircle } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"
import { getMonthAndYear } from "../helpers/dates"

const query = graphql`
  {
    allStrapiJobs(sort: { fields: finish_date, order: DESC }) {
      nodes {
        company
        starting_date
        finish_date
        position
        description {
          id
          name
        }
      }
    }
  }
`

const Jobs = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiJobs: { nodes: jobs },
  } = data

  const [value, setValue] = useState(0)
  const { company, position, starting_date, finish_date, description } = jobs[
    value
  ]

  console.log(jobs)

  return (
    <section className="section jobs">
      <Title title="Experience" />
      <div className="jobs-center">
        {/* Job buttons */}
        <div className="btn-container">
          {jobs.map((job, index) => {
            return (
              <button
                key={job.company}
                onClick={() => setValue(index)}
                className={`job-btn ${index === value && "active-btn"}`}
              >
                {job.company}
              </button>
            )
          })}
        </div>
        {/* Job information */}
        <article className="job-info">
          <h3>{position}</h3>
          <h4>{company}</h4>
          <p className="job-date">
            {`${getMonthAndYear(starting_date)} -
             ${getMonthAndYear(finish_date)}`}
          </p>
          {description.map((item, index) => {
            return (
              <div key={item.id} className="job-desc">
                <FaRegCircle className="job-icon" />
                <p>{item.name}</p>
              </div>
            )
          })}
        </article>
      </div>
      <Link to="/about" className="btn center-btn">
        More about me
      </Link>
      {/* <a
        href="https://drive.google.com/file/d/1XQDnK_A8QNuM794tOSmvKaevUpeP8WdD/view?usp=sharing"
        className="center-text"
        target="_blank"
        rel="noreferrer"
      >
        &rarr; Feel free to check out my CV! &larr;
      </a> */}
    </section>
  )
}

export default Jobs
